import registerElementSettings from './register-element-settings';

export default {
  registerElementSettings,
};
